import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=21c60584&scoped=true&"
import script from "./Changelog.vue?vue&type=script&lang=js&"
export * from "./Changelog.vue?vue&type=script&lang=js&"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=21c60584&lang=scss&scoped=true&"
import style1 from "./Changelog.vue?vue&type=style&index=1&id=21c60584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c60584",
  null
  
)

export default component.exports